module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "Epub4211-4.html",
      "xml:lang": "en-US"
    }
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "PN-I para-style-override-4",
    attrs: {
      "id": "toc_marker-5"
    }
  }, [_c('span', {
    staticClass: "char-style-override-6"
  }, [_vm._v("Copyright © 2013 by John Lawton")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-5"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("All rights reserved. No part of this book may be reproduced in any form or by "), _c('br'), _vm._v("any electronic or mechanical means, including information storage and retrieval "), _c('br'), _vm._v("systems, without permission in writing from the publisher, except by a reviewer, "), _c('br'), _vm._v("who may quote brief passages in a review. Scanning, uploading, and electronic "), _c('br'), _vm._v("distribution of this book or the facilitation of such without the permission of the publisher is prohibited. Please purchase only authorized electronic editions, "), _c('br'), _vm._v("and do not participate in or encourage electronic piracy of copyrighted "), _c('br'), _vm._v("materials. Your support of the author’s rights is appreciated. Any member of "), _c('br'), _vm._v("educational institutions wishing to photocopy part or all of the work for "), _c('br'), _vm._v("classroom use, or anthology, should send inquiries to "), _c('br'), _vm._v("Grove/Atlantic, Inc., 154 West 14th Street, New York, NY 10011 or "), _c('br')]), _c('a', {
    attrs: {
      "href": "mailto:permissions@groveatlantic.com"
    }
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("permissions@groveatlantic.com")])]), _c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-6"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("eBook ISBN-13: 978-0-8021-9308-7")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-6"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Atlantic Monthly Press")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-4"
  }, [_c('span', {
    staticClass: "char-style-override-8"
  }, [_vm._v("an imprint of Grove/Atlantic, Inc.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-4"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("154 West 14th Street")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-4"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("New York, NY 10011")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-7"
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("Distributed by Publishers Group West")])]), _vm._v(" "), _c('p', {
    staticClass: "BT-1st-Para para-style-override-7"
  }, [_c('a', {
    attrs: {
      "href": "http://www.groveatlantic.com",
      "target": "_blank"
    }
  }, [_c('span', {
    staticClass: "char-style-override-7"
  }, [_vm._v("www.groveatlantic.com")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-047058f7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Epub42114.vue
// module id = 72
// module chunks = 0